import { ActivityHeaderSectionLayout } from 'modules/components/layer31';

import * as ds from './dataService';



export type ExternalFolderHeaderSectionProps = {
  folderId: string;
};

export const FC = (props: ExternalFolderHeaderSectionProps) => {
  const { data } = ds.useQuery(props.folderId);

  return (
    <ActivityHeaderSectionLayout.FC
      title={data.folderName}
      subtitle={data.projectAddress}
    />
  );
};
